import { INSTRUMENT_TYPES, INSTRUMENTS } from "."

export function getTradePosition(position, instrumentType) {
  const newInstrumentType = Object.values(INSTRUMENT_TYPES).find((instrument) => !!position.values?.[`composition${INSTRUMENTS[instrument].metricsSuffix}`])

  if (!newInstrumentType) {
    return [position, instrumentType]
  }

  const newPositionComposition = position.values[`composition${INSTRUMENTS[newInstrumentType].metricsSuffix}`]

  const newPosition = {
    ...position,
    ...newPositionComposition,
    id: newPositionComposition.identifier || position.id,
  }

  return [newPosition, newInstrumentType]
}
